<template>
  <div class="live-card">
    <p class="date">{{ computedDate }}</p>
    <div class="card">
      <div class="thumbnail" :style="{ backgroundImage: `url(${liveThumb})` }"></div>
      <a class="profile" :href="channelUrl" target="_blank" rel="noopener">
        <div class="profile-image">
          <img :src="userImg" />
        </div>
        <p class="profile-name">{{ userName }}</p>
      </a>
      <p class="title">{{ liveTitle }}</p>
      <play-button class="button" type="play" :href="liveUrl" target="_blank" rel="noopener">視聴する</play-button>
    </div>
  </div>
</template>

<script>
import PlayButton from '../atoms/PlayButton';

export default {
  name: 'LiveCard',
  components: {
    PlayButton,
  },
  props: {
    liveThumb: String,
    liveTitle: String,
    liveDate: Date,
    liveUrl: String,
    channelId: Number,
    userImg: String,
    userName: String,
  },
  computed: {
    computedDate() {
      const day = '日月火水木金土';
      const date = this.liveDate;

      const m = date.getMonth() + 1;
      const d = date.getDate();
      const you = day[date.getDay()];
      const h = date.getHours();
      const min = `0${date.getMinutes()}`.slice(-2);

      return `${m}月${d}日 (${you}) ${h}:${min}`;
    },
    channelUrl() {
      return `https://ch.nicovideo.jp/channel/ch${this.channelId}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../constants/style';

.live-card {
  display: flex;
  flex-direction: column;
  height: 100%;

  > .date {
    flex: 0 0 69px;
    background: #343438;
    border-radius: 9999px;
    font-weight: bold;
    font-size: 24px;
    line-height: 69px;
    text-align: center;
    color: #ffffff;
    position: relative;
    margin-bottom: 24px;

    &::after {
      background: #343438;
      content: '';
      display: block;
      height: 20px;
      width: 20px;
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%) translateY(-10px) rotate(45deg);
    }
  }

  > .card {
    flex: 1 0 auto;
    display: flex;
    flex-direction: column;
    padding: 32px;
    background: #ffffff;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
    border-radius: 8px;

    > .thumbnail {
      background-color: #f3f3f3;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      position: relative;

      &::before {
        content: '';
        display: block;
        padding-top: 56.25%;
        height: 0;
        width: 100%;
      }
    }

    > .profile {
      color: inherit;
      display: flex;
      align-items: center;
      margin-top: 16px;
      text-decoration: none;

      > .profile-image {
        background: var(--color-black);
        flex: 0 0 36px;
        height: 36px;
        margin-right: 16px;
        text-align: left;
      }
      > .profile-name {
        font-size: 14px;
        font-weight: 500;
      }
    }

    > .title {
      margin-top: 16px;
      font-size: 15px;
      font-weight: bold;
      line-height: 1.4;
      text-align: left;
      margin-bottom: 48px;
    }

    > .button {
      margin: auto auto 0;
      width: 290px;
    }
  }
}

@media #{$mq-sp} {
  .live-card {
    > .date {
      flex: 0 0 48px;
      font-size: 18px;
      line-height: 48px;

      &::after {
      }
    }

    > .card {
      padding: 24px;

      > .profile {
        margin-top: 12px;

        > .profile-image {
          margin-right: 12px;
        }
        > .profile-name {
          font-size: 12px;
          line-height: 1.6;
        }
      }

      > .title {
        font-size: 14px;
        line-height: 1.4;
        margin-bottom: 24px;
      }

      > .button {
        max-width: 240px;
        width: 100%;
      }
    }
  }
}
</style>
